var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMongolia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C13.4679 24 14.874 23.736 16.1739 23.2536L16.6957 12L16.1739 0.746391C14.874 0.264047 13.4679 0 12 0C10.5322 0 9.12605 0.264047 7.82612 0.746391L7.30435 12L7.82607 23.2536C9.12605 23.736 10.5322 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 17.1596 3.2565 21.5581 7.82611 23.2536V0.746399C3.2565 2.44191 0 6.84043 0 12Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 0.746399V23.2537C20.7435 21.5581 24 17.1596 24 12C24 6.84043 20.7435 2.44191 16.1739 0.746399Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73914 12H6.78262V16.1739H5.73914V12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5652 12H2.60869V16.1739H1.5652V12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17389 14.6087C4.75019 14.6087 5.21737 14.1415 5.21737 13.5652C5.21737 12.9889 4.75019 12.5217 4.17389 12.5217C3.59759 12.5217 3.1304 12.9889 3.1304 13.5652C3.1304 14.1415 3.59759 14.6087 4.17389 14.6087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17389 10.4348C4.46203 10.4348 4.69561 10.2012 4.69561 9.91305C4.69561 9.62491 4.46203 9.39133 4.17389 9.39133C3.88576 9.39133 3.65218 9.62491 3.65218 9.91305C3.65218 10.2012 3.88576 10.4348 4.17389 10.4348Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13045 15.1305H5.21742V16.1739H3.13045V15.1305Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13045 10.9565H5.21742V12H3.13045V10.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17389 6.26086L4.54345 7.39805H5.73914L4.77188 8.1009L5.14116 9.23808L4.17389 8.53524L3.20667 9.23808L3.57595 8.1009L2.60869 7.39805H3.80438L4.17389 6.26086Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongolia);
export default __webpack_public_path__ + "static/media/mongolia.8ae764097b783c6731d325437ed6722a.svg";
export { ForwardRef as ReactComponent };